import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-240377cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "empty-wrapper d-flex flex-column align-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "text"
}

import { computed, withDefaults } from 'vue';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    mode?: string,
    text?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    mode: { default: 'data' },
    text: null
  },
  setup(__props: any) {

const props = __props as { mode: string, text?: string }

  const { t } = useI18n();

  
  const map = {
    data: require('@/assets/empty/record.png'),
    search: require('@/assets/empty/search.png')
  };

  const icon = computed(() => {
    return map[props.mode] || map.data;
  });
  const emptyText = computed(() => {
    return props.text || t('No data');
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "empty-img",
      src: _unref(icon)
    }, null, 8, _hoisted_2),
    (_unref(emptyText))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(emptyText)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})